<template>
  <v-container fluid> 
    <v-tabs
      v-model="tabsValue"
      left
      fixed-tabs
      color="secondary"
      slider-color="red"
      dark
    >
      <v-menu bottom offset-y>
        <v-tooltip top slot="activator">
          <v-btn slot="activator" flat icon>
            <v-icon>control_point</v-icon>
          </v-btn>
          <span> {{$vuetify.t('$vuetify.dashboard.tooltips.new')}} </span>
        </v-tooltip>

        <v-list>
          <v-list-tile
            v-for="(item, index) in createMenu"
            :key="index"
            @click="item.code == 'createTab' ? createTab() : addElementDialog()"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-divider vertical></v-divider>
      <v-tab v-for="(item, i) in layout" :key="i">
        {{ item.title }}
        <v-dialog v-if="tabsValue === i"
          v-model="editDialog"
          max-width="500px"
        >
          <v-tooltip top slot="activator">
            <v-btn slot="activator" flat icon>
              <v-icon>edit</v-icon>
            </v-btn>
            <span>{{$vuetify.t('$vuetify.dashboard.tooltips.edittab')}}</span>
          </v-tooltip>
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              {{$vuetify.t('$vuetify.dashboard.dialogs.edit.title')}}
            </v-card-title>

            <v-card-text>
              {{$vuetify.t('$vuetify.dashboard.dialogs.edit.description')}}
            </v-card-text>
            <v-text-field
              name="Title"
              :label="$vuetify.t('$vuetify.dashboard.dialogs.edit.text')"
              id="id"
              :error="newTitleField.length == 0"
              v-model="newTitleField"
            ></v-text-field>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="cancelEdit"
              >
                {{$vuetify.t('$vuetify.dashboard.dialogs.edit.cancel')}}
              </v-btn>
              <v-btn
                color="primary"
                flat
                :disabled="newTitleField.length == 0"
                @click="editTab"
              >
                {{$vuetify.t('$vuetify.dashboard.dialogs.edit.save')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-if="tabsValue === i && layout.length > 1"
          v-model="deleteDialog"
          max-width="500px"
        >
          <v-tooltip top slot="activator">
            <v-btn slot="activator" flat icon>
              <v-icon>delete</v-icon>
            </v-btn>
            <span>{{$vuetify.t('$vuetify.dashboard.tooltips.deletetab')}}</span>
          </v-tooltip>
          <v-card>
            <v-card-title
              class="headline red"
              primary-title
            >
            {{$vuetify.t('$vuetify.dashboard.dialogs.delete.title')}}
            </v-card-title>

            <v-card-text>
              {{$vuetify.t('$vuetify.dashboard.dialogs.delete.description')}}
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="deleteDialog = false"
              >
              {{$vuetify.t('$vuetify.dashboard.dialogs.delete.cancel')}}
              </v-btn>
              <v-btn
                color="red"
                flat
                @click="deleteTab"
              >
              {{$vuetify.t('$vuetify.dashboard.dialogs.delete.save')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab>
      <v-divider horizontal></v-divider>
      <!-- ********************************************************* -->
       <v-dialog
          v-model="exportDialog"
          width="500"
        >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Exporter les données 
        </v-card-title>

        <v-card-text>
        <!-- From date  -->
      <v-layout row wrap>
        <v-flex xs3 lg4>
        <v-menu
          v-model="menu1"
          :close-on-content-click="false"
          full-width
          max-width="250"
        >
          <v-text-field
            slot="activator"
            :value="computedDateFormattedMomentjs"
            clearable
            label="Date de debut"
            readonly
          ></v-text-field>

          <v-date-picker
            v-model="report_fromdate"
            @change="menu1 = false"
            :max="report_todate"
          ></v-date-picker>
        </v-menu>
      </v-flex>


        <!-- Todate -->
       <v-flex xs3 lg4 offset-xs4>
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          full-width
          max-width="250"
        >
          <v-text-field
            slot="activator"
            :value="computedDateFormattedDatefns"
            clearable
            label="Date de fin"
            readonly
          ></v-text-field>
          
          <v-date-picker
            v-model="report_todate"
            @change="menu2 = false"
            :min="report_fromdate"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="exportDialog = false;  exportcsv()"
          >
            Exporter
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
      <v-divider horizontal></v-divider>

      <!-- *************************************************************** -->
       <v-dialog
          v-model="exportSurveyDialog"
          width="500"
        >
          <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Exporter les données des sondages
        </v-card-title>

        <v-card-text>
        <!-- From date  -->
      <v-layout row wrap>
        <v-flex xs3 lg4>
        <v-menu
          v-model="menu3"
          :close-on-content-click="false"
          full-width
          max-width="250"
        >
          <v-text-field
            slot="activator"
            :value="computedDateFormattedMomentjs"
            clearable
            label="Date de debut"
            readonly
          ></v-text-field>

          <v-date-picker
            v-model="report_fromdate"
            @change="menu3 = false"
            :max="report_todate"
          ></v-date-picker>
        </v-menu>
      </v-flex>


        <!-- Todate -->
       <v-flex xs3 lg4 offset-xs4>
        <v-menu
          v-model="menu4"
          :close-on-content-click="false"
          full-width
          max-width="250"
        >
          <v-text-field
            slot="activator"
            :value="computedDateFormattedDatefns"
            clearable
            label="Date de fin"
            readonly
          ></v-text-field>
          
          <v-date-picker
            v-model="report_todate"
            @change="menu4 = false"
            :min="report_fromdate"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      </v-layout>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="exportSurveyDialog = false;  exportSurveycsv()"
          >
            Exporter
          </v-btn>
        </v-card-actions>
      </v-card>

      </v-dialog>

    <!--
    <v-menu bottom offset-y>
        <v-tooltip top slot="activator">
          <v-btn slot="activator" flat icon>
            <v-icon>table_chart</v-icon>
          </v-btn>
          <span> {{$vuetify.t('$vuetify.dashboard.tooltips.export')}} </span>
        </v-tooltip>

        <v-list>
          <v-list-tile
            v-for="(item, index) in createExportMenu"
            :key="index"
            @click="item.code == 'exportComport' ? displayExportComportDialog() : displayExportSurveyDialog()"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      //-->

      <info :title="info.title" :content="info.content"/>
      <v-divider vertical></v-divider>

    </v-tabs>
    <grid-layout :layout="curLayout" :col-num="18" :row-height="50" :is-draggable="true" :is-resizable="true" :vertical-compact="true"
      :use-css-transforms="useCssTransforms">
      <grid-item ref="gridItems" v-for="(item, i) in curLayout" :key="i" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :minH="item.minH" :minW="item.minW" :start-dragging="item.drag" drag-allow-from=".vue-draggable-handle"
        drag-ignore-from=".no-drag" v-if="layoutLoaded">
        <div class="text">
          <v-tooltip top class="vue-draggable-handle">
            <div slot="activator" ></div>
            <span>{{$vuetify.t('$vuetify.dashboard.tooltips.drag')}}</span>
          </v-tooltip>
          
          <div class="vue-delete-btn" @click.stop="erase(i)"></div>

          <v-menu offset-y class="btn">
            <v-tooltip top slot="activator">
              <v-btn slot="activator" icon flat color="grey">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <span>{{ $vuetify.t('$vuetify.dashboard.tooltips.menuButton') }}</span>
            </v-tooltip>
            <v-list>
              <v-list-tile v-for="(menu, menuId) in editMenu" :key="menuId" @click="menuCallback(menuId, i, item.to)">
                <v-list-tile-title>{{ menu.key }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>

          <div class="no-drag">
            <component :is="item.comp" class="comp" v-bind="item.prop"/>
          </div>
        </div>
      </grid-item>
    </grid-layout>
    
    <v-layout column align-center>
      <v-dialog
        v-model="graphDialog"
        max-width="500px"
      >
        <v-card>
          <v-card-title 
            class="headline grey lighten-2 justify-center"
            primary-title
          >
            {{ $vuetify.t('$vuetify.dashboard.dialogs.' + (editMode? 'editgraph' : 'addgraph') + '.title') }}
          </v-card-title>
          <v-tabs
            v-model="active"
            dark
            fixed-tabs
            color="secondary"
            slider-color="red"
          >
             <v-tab :key="behaviour">
              Comportement

            </v-tab>

            <!--
             <v-tab :key="survey">
              Questionnaire

            </v-tab>
            //-->
        <v-tab-item key="behaviour">
          <v-card flat>
          <v-card-text>
            {{ $vuetify.t('$vuetify.dashboard.dialogs.' + (editMode? 'editgraph' : 'addgraph') + '.description') }}
          </v-card-text>
            <v-list>
              <v-list-tile ripple v-for="(item, i) in items" :key="i"  :value="selectedGraph === i" v-on:click="selectedGraph === i ? editMode? dialogEdit() : dialogAdd() : addElement(item.call, i)">
                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-layout row align-end>
                </v-layout>
                <!--<info :title="''" :content="[item.phpName]"/>//-->
              </v-list-tile>
            </v-list>
              </v-card>
            </v-tab-item>

            <v-tab-item key="survey">
          <v-card flat>
          <v-card-text>
            {{ $vuetify.t('$vuetify.dashboard.dialogs.' + (editMode? 'editgraph' : 'addgraph') + '.description') }}
          </v-card-text>
            <v-list>
              <v-list-tile ripple v-for="(item, i) in surveyitems" :key="i"  :value="selectedGraph === i" v-on:click="selectedGraph === i ? editMode? dialogEdit() : dialogAdd() : addElement(item.call, i)">
                <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-layout row align-end>
                </v-layout>
                <!-- <info :title="'PHP'" :content="[item.phpName]"/> //-->
              </v-list-tile>
            </v-list>
              </v-card>
            </v-tab-item>
          </v-tabs>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="graphDialog = !graphDialog"
            >
              {{ $vuetify.t('$vuetify.dashboard.dialogs.' + (editMode? 'editgraph' : 'addgraph') + '.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              flat
              :disabled="selectedGraph === -1"
              @click="editMode? dialogEdit() : dialogAdd()"
            >
              {{ $vuetify.t('$vuetify.dashboard.dialogs.' + (editMode? 'editgraph' : 'addgraph') + '.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import MeanSessionLength from './Charts/MeanSessionLength'
import VueGridLayout from 'vue-grid-layout'
import InfoDialog from './Misc/InfoDialog'
import tpsBarChart from './Charts/TimePerSceneBarChart'
import NumberOfScenesVisited from './Charts/NumberOfScenesVisited'
import NumberOfVisitors from './Charts/NumberOfVisitors'
import NumberOfPagesSeen from './Charts/NumberOfPagesSeen'
import NumberOfProductsAddedToCart from './Charts/NumberOfProductsAddedToCart'
import NumberOfProductsConsulted from './Charts/NumberOfProductsConsulted'
import NumberOfVisits from './Charts/NumberOfVisits'
import RatingsPerSession from './Charts/RatingsPerSession'
import MeanRatingsPerPeriod from './Charts/MeanRatingsPerPeriod'
import NumberOfVisitsFromSeat from './Charts/NumberOfVisitsFromSeat'
import AllClickedItems from './Charts/AllClickedItems'
import ClicksPerSession from './Charts/ClicksPerSession'
import ScenesPerSession from './Charts/ScenesPerSession'
import VisitorsPerHour from './Charts/VisitorsPerHour'
const axios = require('axios')

var gridLayout = VueGridLayout.GridLayout
var gridItem = VueGridLayout.GridItem
const serverDir = process.env.API_URL
import moment from 'moment'
import format from 'date-fns/format'

// const axios = require('axios')

export default {
  props: {
    tab: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: function() {
    return {
      items: [],
      /*surveyitems: [
          {
          icon: 'insert_chart',
          category:'survey',
          title: this.$vuetify.t('$vuetify.charts.surveyCompletionRatio.legend'),
          phpName: 'SurveyCompletionRatio.php',
          call: {
            props: {barStyle: 'height: calc(100% - 24px);', dashMode: true},
            comp: 'survey-completion-ratio',
            to: '/time?graph=1'
          }
        },
         {
          icon: 'insert_chart',
          category:'survey',
          title: this.$vuetify.t('$vuetify.charts.surveyOverview.legend'),
          phpName: 'SurveyAgreementRate.php',
          call: {
            props: {barStyle: 'height: calc(100% - 24px);', dashMode: true},
            comp: 'survey-overview',
            to: '/time?graph=1'
          }
        },
       ],*/
      layout: [
        {
          title: 'Dashboard',
          layout: []
        }
        // ,
        // {
        //   title: 'Dashboard 2',
        //   layout: [
        //     {'drag': false, 'x': 0, 'y': 0, 'w': 6, 'h': 4, 'i': '0', 'minH': 4, 'minW': 6, 'to': '/test?graph=0', 'prop': {}, 'comp': 'mean-session-length'},
        //     {'drag': false, 'x': 8, 'y': 0, 'w': 6, 'h': 4, 'i': '1', 'minH': 4, 'minW': 6, 'to': '/test?graph=1', 'prop': {}, 'comp': 'number-of-visits'}
        //   ]
        // }
      ],
      curLayout: [],
      rightDrawer: false,
      useCssTransforms: true,
      tabsValue: null,
      info: {
        title: this.$vuetify.t('$vuetify.info.dashboard.title'),
        content: [
          this.$vuetify.t('$vuetify.info.dashboard.content.1'),
          this.$vuetify.t('$vuetify.info.dashboard.content.2'),
          this.$vuetify.t('$vuetify.info.dashboard.content.3')]
      },
      editDialog: false,
      deleteDialog: false,
      graphDialog: false,
      exportDialog: false,
      exportSurveyDialog: false,
      ENV_ID: '',
      editMode: false,
      toEdit: -1,
      selectedGraph: -1,
      report_fromdate: null,
      report_todate: null,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      layoutLoaded: false,
      newTitleField: '',
      currentUser_RightsGroups: [],
      createMenu: [
        {
          title: this.$vuetify.t('$vuetify.dashboard.menu.create.addtab'),
          code: 'createTab'
        },
        {
          title: this.$vuetify.t('$vuetify.dashboard.menu.create.addgraph'),
          code: 'createGraph'
        }
      ],
      createExportMenu: [
        {
          title: this.$vuetify.t('$vuetify.dashboard.menu.export.exportComport'),
          code: 'exportComport'
        },
        {
          title: this.$vuetify.t('$vuetify.dashboard.menu.export.exportSurvey'),
          code: 'exportSurvey'
        }
      ],
      editMenu: [
        {
          key: this.$vuetify.t('$vuetify.dashboard.menu.graph.changeButton')
        }
      ],
      toAdd: {
        props: '',
        comp: '',
        to: ''
      }
    }
  },
  components: {
    'grid-layout': gridLayout,
    'grid-item': gridItem,
    'mean-session-length': MeanSessionLength,
    'tps-chart': tpsBarChart,
    'all-clicked-items': AllClickedItems,
    'scenes-per-session': ScenesPerSession,
    'clicks-per-session': ClicksPerSession,
    'visitors-per-hour': VisitorsPerHour,
    'number-of-pages-seen': NumberOfPagesSeen,
    'number-of-scenes-visited': NumberOfScenesVisited,
    'number-of-visitors': NumberOfVisitors,
    'number-of-products-added-to-cart': NumberOfProductsAddedToCart,
    'number-of-products-consulted': NumberOfProductsConsulted,
    'number-of-visits': NumberOfVisits,
    'ratings-per-session': RatingsPerSession,
    'mean-ratings-per-period': MeanRatingsPerPeriod,
    'number-of-visits-from-seat': NumberOfVisitsFromSeat,
    'info': InfoDialog,
  },
  watch: {
    layout: {
      handler: function (_) {
        this.saveLayout()
        this.layoutLoaded = true
        this.curLayout = this.layout[this.tabsValue].layout
      },
      deep: true,
      immediate: false,
    },
    tabsValue (value) {
      // this.$router.replace(this.$route.path + '?tab=' + value)
      this.curLayout = this.layout[value].layout
      console.log(this.layout[value].title)
      this.newTitleField = this.layout[value].title
    }
  },
  created () {
    // If there is no layout in the localStorage, there will be an error: a try/catch allows to do what we want.
    try{
      var layoutInLocalStorage = JSON.parse(localStorage.layout)
    } 
    catch (error){
      // On ne devrait jamais passer par là sauf lors de la première connexion d'un utilisateur (ou si l'utilisateur se reconnecte après avoir vidé le cache)
      var x = setInterval(() => {
        this.currentUser_RightsGroups = JSON.parse(this.$root.$children[0].currentUser_RightsGroupsStringified)
        if (this.currentUser_RightsGroups != []){
          clearInterval(x)
          if (this.currentUser_RightsGroups.includes('GlobalStats') && this.currentUser_RightsGroups.includes('DetailedStats') && this.currentUser_RightsGroups.includes('ExpertStats')){
            this.layout = [
              {
                  title: 'Dashboard',
                  layout: [
                  {'drag': false, 'x': 0, 'y': 0, 'w': 8, 'h': 6, 'i': '0', 'minH': 4, 'minW': 6, 'to': '/test?graph=0', 'prop': {}, 'comp': 'number-of-visits'},
                  {'drag': false, 'x': 10, 'y': 0, 'w': 8, 'h': 6, 'i': '1', 'minH': 4, 'minW': 6, 'to': '/test?graph=1', 'prop': {}, 'comp': 'number-of-visits-from-seat'},
                  {'drag': false, 'x': 0, 'y': 6, 'w': 8, 'h': 6, 'i': '2', 'minH': 4, 'minW': 6, 'to': '/test?graph=2', 'prop': {}, 'comp': 'number-of-visitors'},
                  {'drag': false, 'x': 10, 'y': 6, 'w': 8, 'h': 6, 'i': '3', 'minH': 4, 'minW': 6, 'to': '/test?graph=3', 'prop': {}, 'comp': 'tps-chart'},
                  {'drag': false, 'x': 0, 'y': 12, 'w': 8, 'h': 6, 'i': '4', 'minH': 4, 'minW': 6, 'to': '/test?graph=4', 'prop': {}, 'comp': 'number-of-products-added-to-cart'},
                  {'drag': false, 'x': 10, 'y': 12, 'w': 8, 'h': 6, 'i': '5', 'minH': 4, 'minW': 6, 'to': '/test?graph=5', 'prop': {}, 'comp': 'number-of-products-consulted'},
                  {'drag': false, 'x': 0, 'y': 18, 'w': 8, 'h': 6, 'i': '6', 'minH': 4, 'minW': 6, 'to': '/test?graph=6', 'prop': {}, 'comp': 'mean-session-length'},
                  {'drag': false, 'x': 10, 'y': 18, 'w': 8, 'h': 6, 'i': '7', 'minH': 4, 'minW': 6, 'to': '/test?graph=7', 'prop': {}, 'comp': 'number-of-scenes-visited'}
                  ]
              }
            ]
            this.items = [
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.timePerScene.legend'),
                phpName: 'TimePerScene',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'tps-chart',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.allClickedItems.legend'),
                phpName: 'AllClickedItems',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'all-clicked-items',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.scenesPerSession.legend'),
                phpName: 'ScenesPerSession',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'scenes-per-session',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.clicksPerSession.legend'),
                phpName: 'ClicksPerSession',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'clicks-per-session',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.visitorsPerHour.legend'),
                phpName: 'VisitorsPerHour',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'visitors-per-hour',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfScenesVisited.legend'),
                phpName: 'NumberOfScenesVisited',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-scenes-visited',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisitors.legend'),
                phpName: 'NumberOfVisitors',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visitors',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfPagesSeen.legend'),
                phpName: 'NumberOfPagesSeen',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-pages-seen',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfProductsAddedToCart.legend'),
                phpName: 'NumberOfProductsAddedToCart',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-products-added-to-cart',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfProductsConsulted.legend'),
                phpName: 'NumberOfProductsConsulted',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-products-consulted',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisits.legend'),
                phpName: 'NumberOfVisits',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visits',
                  to: '/scenes?graph=0'
                }
              },
                {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.ratingsPerSession.legend'),
                phpName: 'RatingsPerSession',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'ratings-per-session',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.meanRatingsPerPeriod.legend'),
                phpName: 'MeanRatings',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'mean-ratings-per-period',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisitsFromSeat.legend'),
                phpName: 'NumberOfVisitsFromSeat',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visits-from-seat',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.meanSessionLength.legend'),
                phpName: 'MeanSessionLength',
                call: {
                  props: {barStyle: 'height: calc(100% - 34px);', dashMode: true},
                  comp: 'mean-session-length',
                  to: '/time?graph=3'
                }
              }
            ]
          }
          else if (this.currentUser_RightsGroups.includes('GlobalStats') && this.currentUser_RightsGroups.includes('DetailedStats')){
            this.layout = [
              {
                  title: 'Dashboard',
                  layout: [
                  {'drag': false, 'x': 0, 'y': 0, 'w': 8, 'h': 6, 'i': '0', 'minH': 4, 'minW': 6, 'to': '/test?graph=0', 'prop': {}, 'comp': 'number-of-visits'},
                  {'drag': false, 'x': 10, 'y': 0, 'w': 8, 'h': 6, 'i': '1', 'minH': 4, 'minW': 6, 'to': '/test?graph=1', 'prop': {}, 'comp': 'number-of-visits-from-seat'},
                  {'drag': false, 'x': 0, 'y': 6, 'w': 8, 'h': 6, 'i': '2', 'minH': 4, 'minW': 6, 'to': '/test?graph=2', 'prop': {}, 'comp': 'number-of-visitors'},
                  {'drag': false, 'x': 10, 'y': 6, 'w': 8, 'h': 6, 'i': '3', 'minH': 4, 'minW': 6, 'to': '/test?graph=3', 'prop': {}, 'comp': 'tps-chart'},
                  {'drag': false, 'x': 0, 'y': 12, 'w': 8, 'h': 6, 'i': '4', 'minH': 4, 'minW': 6, 'to': '/test?graph=4', 'prop': {}, 'comp': 'number-of-products-added-to-cart'},
                  {'drag': false, 'x': 10, 'y': 12, 'w': 8, 'h': 6, 'i': '5', 'minH': 4, 'minW': 6, 'to': '/test?graph=5', 'prop': {}, 'comp': 'number-of-products-consulted'},
                  {'drag': false, 'x': 0, 'y': 18, 'w': 8, 'h': 6, 'i': '6', 'minH': 4, 'minW': 6, 'to': '/test?graph=6', 'prop': {}, 'comp': 'mean-session-length'},
                  ]
              }
            ]
            this.items = [
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.timePerScene.legend'),
                phpName: 'TimePerScene',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'tps-chart',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.clicksPerSession.legend'),
                phpName: 'ClicksPerSession',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'clicks-per-session',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.visitorsPerHour.legend'),
                phpName: 'VisitorsPerHour',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'visitors-per-hour',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisitors.legend'),
                phpName: 'NumberOfVisitors',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visitors',
                  to: '/scenes?graph=0'
                }
              },
                {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.ratingsPerSession.legend'),
                phpName: 'RatingsPerSession',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'ratings-per-session',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.meanRatingsPerPeriod.legend'),
                phpName: 'MeanRatings',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'mean-ratings-per-period',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfPagesSeen.legend'),
                phpName: 'NumberOfPagesSeen',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-pages-seen',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfProductsAddedToCart.legend'),
                phpName: 'NumberOfProductsAddedToCart',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-products-added-to-cart',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfProductsConsulted.legend'),
                phpName: 'NumberOfProductsConsulted',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-products-consulted',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisits.legend'),
                phpName: 'NumberOfVisits',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visits',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisitsFromSeat.legend'),
                phpName: 'NumberOfVisitsFromSeat',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visits-from-seat',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.meanSessionLength.legend'),
                phpName: 'MeanSessionLength',
                call: {
                  props: {barStyle: 'height: calc(100% - 34px);', dashMode: true},
                  comp: 'mean-session-length',
                  to: '/time?graph=3'
                }
              }
            ]
          }
          else if (this.currentUser_RightsGroups.includes('GlobalStats')){
            this.layout = [
              {
                  title: 'Dashboard',
                  layout: [
                  {'drag': false, 'x': 0, 'y': 0, 'w': 8, 'h': 6, 'i': '0', 'minH': 4, 'minW': 6, 'to': '/test?graph=0', 'prop': {}, 'comp': 'number-of-visits'},
                  {'drag': false, 'x': 10, 'y': 0, 'w': 8, 'h': 6, 'i': '1', 'minH': 4, 'minW': 6, 'to': '/test?graph=1', 'prop': {}, 'comp': 'number-of-visits-from-seat'},
                  {'drag': false, 'x': 0, 'y': 6, 'w': 8, 'h': 6, 'i': '2', 'minH': 4, 'minW': 6, 'to': '/test?graph=2', 'prop': {}, 'comp': 'number-of-visitors'},
                  ]
              }
            ]
            this.items = [
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisitors.legend'),
                phpName: 'NumberOfVisitors',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visitors',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfPagesSeen.legend'),
                phpName: 'NumberOfPagesSeen',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-pages-seen',
                  to: '/scenes?graph=0'
                }
              },
                {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.ratingsPerSession.legend'),
                phpName: 'RatingsPerSession',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'ratings-per-session',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.meanRatingsPerPeriod.legend'),
                phpName: 'MeanRatings',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'mean-ratings-per-period',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisits.legend'),
                phpName: 'NumberOfVisits',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visits',
                  to: '/scenes?graph=0'
                }
              },
              {
                icon: 'insert_chart',
                category:'behaviour',
                title: this.$vuetify.t('$vuetify.charts.numberOfVisitsFromSeat.legend'),
                phpName: 'NumberOfVisitsFromSeat',
                call: {
                  props: {barStyle: 'height: calc(100% - 24px);'},
                  comp: 'number-of-visits-from-seat',
                  to: '/scenes?graph=0'
                }
              }
            ]
          }
        }
      }, 200)
    }
  },
  mounted () {
    this.tabsValue = this.tab
    this.loadLayout()
  },
  computed: {
    computedDateFormattedMomentjs () {
      console.log('from date is: ' + this.report_fromdate)
      return this.report_fromdate
    },
    computedDateFormattedDatefns () {
      console.log('todate is: ' + this.report_todate)
      return this.report_todate
    }
  },
  methods: {
    saveLayout: function () {
      localStorage.layout = JSON.stringify(this.layout)
    },
    loadLayout: function () {
      if (localStorage.layout) {
        this.layout = JSON.parse(localStorage.layout)
      }
    },
    addElement: function (call, id) {
      this.toAdd.prop = call.props
      this.toAdd.component = call.comp
      this.toAdd.to = call.to
      this.toAdd.minh = call.minh
      this.toAdd.minw = call.minw
      this.selectedGraph = id
    },
    dialogAdd: function () {
      var prop = this.toAdd.prop
      var component = this.toAdd.component
      var to = this.toAdd.to
      var minh = this.toAdd.minh || 4
      var minw = this.toAdd.minw || 6

      this.layout[this.tabsValue].layout.push(
        {'drag': true, 'x': 0, 'y': 99, 'w': minw, 'h': minh, 'i': this.layout[this.tabsValue].layout.length.toString(), 'minH': minh, 'minW': minw, 'to': to, 'prop': prop, 'comp': component}
      )
      this.selectedGraph = -1
      this.graphDialog = false
    },
    dialogEdit: function () {
      var id = this.toEdit
      this.layout[this.tabsValue].layout[id].prop = this.toAdd.prop
      this.layout[this.tabsValue].layout[id].comp = this.toAdd.component
      this.layout[this.tabsValue].layout[id].to = this.toAdd.to
      this.selectedGraph = -1
      this.graphDialog = false
    },
    addElementDialog: function () {
      this.editMode = false
      this.graphDialog = true
    },

    displayExportComportDialog: function () {
      this.editMode = false
      this.exportDialog = true
    },

    displayExportSurveyDialog: function () {
      this.editMode = false
      this.exportSurveyDialog = true
    },
    editElement: function (id) {
      this.editMode = true
      this.toEdit = id
      this.graphDialog = true
    },
    erase: function (index) {
      var id = +index
      this.layout[this.tabsValue].layout.splice(id, 1)
      for (let i = id; i < this.layout[this.tabsValue].layout.length; i++) {
        const element = this.layout[this.tabsValue].layout[i]
        element.i = (+element.i - 1).toString()
      }
    },
    exportcsv: function () {
      console.log(this)
      var ENV_ID = this.$route.query.ENV_ID
      axios.get(serverDir + 'CreateCsvReport.php?' + '&start=' + this.report_fromdate + '&end=' + this.report_todate + '&ENV_ID=' + ENV_ID)
      .then(function (response) {
        self.startdate = response.data.startdate
        self.todate = response.data.todate
        self.environmentID = response.data.environmentID
        window.location.href = serverDir + 'exports/comport/' + ENV_ID + '_' + self.startdate + '-' + self.todate + '.csv'
      })
      .catch(function (error) {
        // handle error
        self.loadFailed = true
        self.failedOnList = true
        console.log(error)
      })
      .then(function () {
        self.isLoading = false
      })
    },
    exportSurveycsv: function () {
      // console.log(this)
      var ENV_ID = this.$route.query.ENV_ID
      axios.get(serverDir + 'ExportSurveyData.php?' + '&start=' + this.report_fromdate + '&end=' + this.report_todate + '&ENV_ID=' + ENV_ID)
      .then(function (response) {
        self.startdate = response.data.startdate
        self.todate = response.data.todate
        self.environmentID = response.data.environmentID
        window.location.href = serverDir + 'exports/surveydata/' + ENV_ID + '_' + self.startdate + '-' + self.todate + '.csv'
      })
      .catch(function (error) {
        // handle error
        self.loadFailed = true
        self.failedOnList = true
        console.log(error)
      })
      .then(function () {
        self.isLoading = false
      })
    },
    createTab: function () {
      this.layout.push(
        {
          title: this.$vuetify.t('$vuetify.dashboard.newTabTitle'),
          layout: []
        })
      this.tabsValue = this.layout.length - 1
    },
    cancelEdit: function () {
      this.editDialog = false
      setTimeout(() => {
        this.newTitleField = this.layout[this.tabsValue].title
      }, 200)
    },
    editTab: function () {
      this.layout[this.tabsValue].title = this.newTitleField
      this.editDialog = false
      var tab = this.tabsValue
      this.tabsValue = -1
      setTimeout(() => {
        this.tabsValue = tab
      }, 0)
    },
    deleteTab: function () {
      this.layout.splice(this.tabsValue, 1)
      this.deleteDialog = false
      this.tabsValue -= this.tabsValue >= this.layout.length
      this.curLayout = this.layout[this.tabsValue].layout
      this.newTitleField = this.layout[this.tabsValue].title
    },
    menuCallback: function (menuID, graphID, to) {
      switch (menuID) {
        case 0:
          this.editElement(graphID)
          break
        default:
          console.warn('menuCallback: wrong ID (' + menuID + ') for menuId')
          break
      }
    }
  },
  name: 'Test'
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.segment {
  width: 100%;
  float: left;
  align-content:center;
}
.chart {
  padding: 20px;
  background: #EEFFFF;
}

.vue-grid-layout {
  background: #eee;
}

.layoutJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
}

.eventsJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
    height: 100px;
    overflow-y: scroll;
}

.columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
}



.vue-resizable-handle {
    z-index: 5000;
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=');
    background-position: bottom right;
    padding: 0 3px 3px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: se-resize;
}

.vue-grid-item:not(.vue-grid-placeholder) {
    background: rgb(255, 255, 255);
    border: 1px solid grey;
}

.vue-grid-item.resizing {
    opacity: 0.9;
}

.vue-grid-item.static {
    background: rgb(255, 255, 255);
}

.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}

.vue-grid-item .no-drag {
  margin: 2px 20px 20px 2px;
  padding: 2px 20px 20px 2px;
  width: 100%;
  height: 100%;
}
.vue-grid-item .no-drag .comp {
  width: 100%;
  height: 100%;
}
.vue-grid-item .btn {
  margin-top: -10px;
  margin-left: calc(50% - 70px);
  position: absolute;
}

.vue-grid-item .minMax {
    font-size: 12px;
}

.vue-grid-item .add {
    cursor: pointer;
}

.vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='%23999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: move;
}

.vue-delete-btn {
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    right: 0;
    background: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA4IDgiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOiM5OTk7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5kcmFnIEljb248L3RpdGxlPjxyZWN0IGNsYXNzPSJhIiB4PSItMC4wMiIgeT0iMi44NSIgd2lkdGg9IjgiIGhlaWdodD0iMi4zNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC4wMSAtMS42Mykgcm90YXRlKDQ1KSIvPjxyZWN0IGNsYXNzPSJhIiB5PSIyLjgzIiB3aWR0aD0iOCIgaGVpZ2h0PSIyLjM0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS42NiA0KSByb3RhdGUoLTQ1KSIvPjwvc3ZnPg==') no-repeat;
    background-position: bottom left;
    padding: 0 0 8px 9px;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue